import { render, staticRenderFns } from "./TestPassageStatus.vue?vue&type=template&id=12c0d4b0&scoped=true&"
import script from "./TestPassageStatus.vue?vue&type=script&lang=js&"
export * from "./TestPassageStatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12c0d4b0",
  null
  
)

export default component.exports